import React from "react";
import NextStopComplianceGrid from "./NextStopComplianceGrid/index";
import NextStopComplianceMapDetails from "./NextStopComplianceMap/index";
import Events from "../../../../utilities/EventEmitter";
import { RMAXLogger } from "../../../../services/LoggerService/RMAXLogger";

class NextStopComplianceReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openMap: false,
      routeComplianceList: [],
      nextStopComplianceSelectedRoute: null,
      nextStopComplianceDate: null,
    };
  }

  goBack = () => {
    this.props.hideReportsListItem(true);
    //Show KPI on grid view
    Events.emit("showKpi");
    this.setState({
      openMap: false,
      nextStopComplianceSelectedRoute: null,
    });
  };

  openMapView = (route, routeComplianceList) => {
    this.props.hideReportsListItem(false);
    //Hide KPI on grid view
    Events.emit("hideKpi");
    this.setState({
      openMap: true,
      nextStopComplianceSelectedRoute: route,
      routeComplianceList: routeComplianceList,
    });
    RMAXLogger.info("NextStopComplianceRouteSelected", {
      routeId: route?.routeId,
      routeName: route?.routeName,
      driverId: route?.driverId,
      manifestNumber: route?.manifestNumber,
    });
  };

  updateNextStopComplianceSelectedRoute = (route) => {
    this.setState({
      nextStopComplianceSelectedRoute: route,
    });
    RMAXLogger.info("NextStopComplianceRouteSelected", {
      routeId: route?.routeId,
      routeName: route?.routeName,
      driverId: route?.driverId,
      manifestNumber: route?.manifestNumber,
    });
  };

  updateNextStopComplianceDate = (date) => {
    if (this.state.nextStopComplianceDate !== date) {
      this.setState({
        nextStopComplianceDate: date,
      });
    }
  };

  render() {
    const {
      openMap,
      routeComplianceList,
      nextStopComplianceSelectedRoute,
      nextStopComplianceDate,
    } = this.state;
    return (
      <div>
        {openMap ? (
          <NextStopComplianceMapDetails
            goBack={this.goBack}
            routeComplianceList={routeComplianceList}
            nextStopComplianceSelectedRoute={nextStopComplianceSelectedRoute}
            updateNextStopComplianceSelectedRoute={
              this.updateNextStopComplianceSelectedRoute
            }
          ></NextStopComplianceMapDetails>
        ) : (
          <NextStopComplianceGrid
            openMapView={this.openMapView}
            nextStopComplianceDate={nextStopComplianceDate}
            updateNextStopComplianceDate={this.updateNextStopComplianceDate}
          ></NextStopComplianceGrid>
        )}
      </div>
    );
  }
}

export default NextStopComplianceReports;
